const isEmpty = (value) => {
	// Undefined or null
	if (value === undefined || value === null) return true

	// Boolean (never empty)
	if (typeof value === 'boolean') return false

	// Numbers (0 is not "empty" in this context)
	if (typeof value === 'number') return false

	// Strings (empty or whitespace-only strings)
	if (typeof value === 'string') return value.trim().length === 0

	// Arrays (empty arrays)
	if (Array.isArray(value)) return value.length === 0

	// Objects (empty plain objects, exclude special types)
	if (typeof value === 'object') {
		if (
			value instanceof File ||
			value instanceof Blob ||
			value instanceof Map ||
			value instanceof Set ||
			value instanceof Date
		)
			return false // Special object types are not considered "empty"

		return Object.keys(value).length === 0
	}

	// Maps and Sets (empty collections)
	if (value instanceof Map || value instanceof Set) return value.size === 0

	// Dates (never "empty")
	if (value instanceof Date) return false

	// Functions (never "empty")
	if (typeof value === 'function') return false

	// Any other types (fallback to "not empty")
	return false
}

export default isEmpty
